import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import Preload from '../../../js/components/preloader.js';
import { url } from '../../../js/api/endpoint';
import language from '../../../js/stores/language.js';
import themes from '../../../js/stores/theme.js';
import user from '../../../js/stores/user.js';
import car from '../../../js/stores/car.js';
import carPricing from '../../../js/stores/car-pricing.js';
import carManufacturer from '../../../js/stores/car-manufacturer.js';
import file from '../../../js/stores/file.js';
import restrictedDate from '../../../js/stores/restricted-date.js';
import Uploader from '../../../js/controllers/uploader.js';
import restrictedDatesLibrary from '../../../js/controllers/restricted-dates-lib.js';
import carFeatureLibrary from '../../../js/controllers/car-feature-lib.js';
import CarFeatures from './features.f7.html';
import datetimePicker from '../../../js/components/pickertime.js';
import * as dayjs from 'dayjs';
import { FileUploadWithPreview } from 'file-upload-with-preview';
import '../../../css/car-component-data-tab.css';
var CarDataTab = function CarDataTab(props, _ref) {
  var $h = _ref.$h,
    $ = _ref.$,
    $on = _ref.$on,
    $f7 = _ref.$f7,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var carId = user.getters.carId.value;
  var carPricings = [];
  var uploaderCarImage = null;
  var uploaderCarPlate = null;
  var uploadCarFileList = null;
  var carFile = {};
  var plateFile = {};
  var carImageFileList = [];
  var carImageListPhotos = [];
  var carImageListBrowser;
  var details = props.details;
  var isCarImageEmpty = false;
  var isCarPlateEmpty = false;
  var restrictorCalendar = null;
  var disabledDates = [];
  var listRestricted = [];
  var dateValue = "";
  $f7.on('updateFeatures', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return carFeatureLibrary.getLocalizedData(carId, 1);
        case 1:
          props.details.CarFeatureList = _context.sent;
          _context.next = 2;
          return carFeatureLibrary.getLocalizedData(carId, 2);
        case 2:
          props.details.CarUseRestrictionList = _context.sent;
          _context.next = 3;
          return carFeatureLibrary.getLocalizedData(carId, 3);
        case 3:
          props.details.CarPenaltyUseList = _context.sent;
          $update();
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  $on('pageBeforeRemove', function () {
    $f7.off('updateFeatures');
  });
  var extraSetup = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            configFileUploaders();
            _context2.next = 1;
            return configManufacturerAutocomplete();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function extraSetup() {
      return _ref3.apply(this, arguments);
    };
  }();
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var result, carFileData, plateFileData, carListFiles, fileIds, i, urlFile, cfgDeliveryTime, cfgReturnTime;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 1;
          return carPricing.dispatch('getList');
        case 1:
          result = _context4.sent;
          if (result.status !== undefined && result.status !== 200) {
            console.log(result.data.messages.error);
            result = [];
          }
          carPricings = result;
          _context4.next = 2;
          return file.dispatch('getCarImage', carId);
        case 2:
          carFileData = _context4.sent;
          carFile.fileId = carFileData.FileId;
          carFile.url = "".concat(url, "/").concat(carFileData.FilePath, "/").concat(carFileData.FileName);
          if (carFileData.FilePath.length == 0 && carFileData.FileName.length == 0) {
            isCarImageEmpty = true;
          }
          _context4.next = 3;
          return file.dispatch('getCarPlate', carId);
        case 3:
          plateFileData = _context4.sent;
          plateFile.fileId = plateFileData.FileId;
          plateFile.url = "".concat(url, "/").concat(plateFileData.FilePath, "/").concat(plateFileData.FileName);
          if (plateFileData.FilePath.length == 0 && plateFileData.FileName.length == 0) {
            isCarPlateEmpty = true;
          }
          _context4.next = 4;
          return file.dispatch('getCarImageList', carId);
        case 4:
          carListFiles = _context4.sent;
          fileIds = [];
          carImageListPhotos = [];
          for (i = 0; i < carListFiles.length; i++) {
            fileIds.push(carListFiles[i].FileId);
            if (!(carListFiles[i].FilePath.length == 0 && carListFiles[i].FileName.length == 0)) {
              urlFile = "".concat(url, "/").concat(carListFiles[i].FilePath, "/").concat(carListFiles[i].FileName);
              carImageListPhotos.push(urlFile);
            }
          }
          carImageFileList = fileIds.join();
          if (carImageListPhotos.length > 0) {
            carImageListBrowser = $f7.photoBrowser.create({
              photos: carImageListPhotos,
              theme: themes.getters.Name.value
            });
          }

          /*Update calendar (previous, ongoing & restricted dates) values */
          _context4.next = 5;
          return restrictedDatesLibrary.refreshDisabledDates(carId);
        case 5:
          disabledDates = restrictedDatesLibrary.disabledDates;
          configRestrictorCalendar();
          updateDisabledDates();
          setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function (_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  extraSetup();
                case 1:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          })), 250);
          cfgDeliveryTime = datetimePicker.timeConfig('#car-preferred-delivery-time');
          cfgReturnTime = datetimePicker.timeConfig('#car-preferred-return-time');
          $f7.picker.create(cfgDeliveryTime);
          $f7.picker.create(cfgReturnTime);
          if (props.details.CarMainData.CarPreferredDeliveryTime != null) document.getElementById('car-preferred-delivery-time').value = props.details.CarMainData.CarPreferredDeliveryTime;
          if (props.details.CarMainData.CarPreferredReturnTime != null) document.getElementById('car-preferred-return-time').value = props.details.CarMainData.CarPreferredReturnTime;
          $update();
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })));
  $on('pageBeforeRemove', function () {
    restrictorCalendar.destroy();
  });
  var configManufacturerAutocomplete = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var manufacturers, manufacturerList, config, newObj;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 1;
            return carManufacturer.dispatch('getFullList');
          case 1:
            manufacturers = _context5.sent;
            manufacturerList = manufacturers.map(function (item) {
              return {
                id: item.CarManufacturerId,
                text: item.CarManufacturerName
              };
            });
            config = Preload.Autocomplete(manufacturerList, '#car-manufacturer-name', 'car-manufacturer-id');
            newObj = _objectSpread({}, config);
            $f7.autocomplete.destroy('#car-manufacturer-name');
            $f7.autocomplete.create(newObj);
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function configManufacturerAutocomplete() {
      return _ref6.apply(this, arguments);
    };
  }();
  var checkUseCar = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
      var data, result;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!(props.details.CarStatusId > 1)) {
              _context6.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('car.edit.carIsUsedStatusMessage')
            });
            e.preventDefault();
            return _context6.abrupt("return");
          case 1:
            data = {
              CarId: user.getters.carId.value,
              CarStatusId: $("#car-is-used").prop('checked') ? 1 : 0
            };
            _context6.next = 2;
            return car.dispatch('toggleUse', data);
          case 2:
            result = _context6.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context6.next = 3;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context6.abrupt("return");
          case 3:
            props.details.CarMainData.CarStatusId = data.CarStatusId;
            $update();
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function checkUseCar(_x) {
      return _ref7.apply(this, arguments);
    };
  }();
  var checkPrice = function checkPrice(e) {
    validatePrice(e.target.value);
  };
  var validatePrice = function validatePrice(value) {
    var carSizeElem = document.getElementById('car-size');
    var price = Number(value);
    var i = Number(carSizeElem.selectedIndex);
    if (i < 1) {
      $f7.toast.show({
        text: locale.translate('car.edit.checkSizeMessage')
      });
      document.getElementById('car-price-rent').value = 0;
      return false;
    }
    var minRecommendedPrice = Number(carPricings[i].MinRecommendedPrice);
    var maxRecommendedPrice = Number(carPricings[i].MaxRecommendedPrice);
    if (price < minRecommendedPrice || price > maxRecommendedPrice) {
      $f7.toast.show({
        text: locale.translate('car.edit.recommendedPriceMessage', [carSizeElem.options[i].text, minRecommendedPrice, maxRecommendedPrice])
      });
      return false;
    }
    return true;
  };
  var showRestrictingCalendar = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            restrictorCalendar.open();
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function showRestrictingCalendar() {
      return _ref8.apply(this, arguments);
    };
  }();
  var openCarImageListBrowser = function openCarImageListBrowser() {
    carImageListBrowser.open();
  };
  var configFileUploaders = function configFileUploaders() {
    uploadCarFileList = new FileUploadWithPreview('car-data-images', {
      maxFileCount: 6,
      multiple: true,
      accept: 'image/jpeg,image/jpg',
      text: {
        label: locale.translate('car.edit.uploadCarImagesLabel'),
        browse: locale.translate('general.browse'),
        chooseFile: locale.translate('general.chooseFileLabel'),
        selectedCount: locale.translate('general.selectedCountLabel')
      }
    });
    var uploaderCarConfig = new Uploader({
      input: document.querySelector('.js-fileinput-car'),
      types: ['gif', 'jpg', 'jpeg', 'png']
    });
    var uploaderCarPlateConfig = new Uploader({
      input: document.querySelector('.js-fileinput-car-plate'),
      types: ['gif', 'jpg', 'jpeg', 'png']
    });
    uploaderCarImage = uploaderCarConfig;
    uploaderCarPlate = uploaderCarPlateConfig;
    if (uploaderCarImage) {
      uploaderCarImage.listen(function (result) {
        if (document.getElementById('car-img').classList.contains('hideable')) {
          document.getElementById('car-img').classList.remove('hideable');
        }
        document.getElementById('car-img').src = result;
      });
    }
    if (uploaderCarPlate) {
      uploaderCarPlate.listen(function (result) {
        if (document.getElementById('car-plate-img').classList.contains('hideable')) {
          document.getElementById('car-plate-img').classList.remove('hideable');
        }
        document.getElementById('car-plate-img').src = result;
      });
    }
  };
  var saveCarData = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var formCarData, value, isValid, result;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            formCarData = $f7.form.convertToData('#car-form-edition');
            value = document.getElementById('car-price-rent').value;
            isValid = validatePrice(value);
            if (isValid) {
              _context8.next = 1;
              break;
            }
            return _context8.abrupt("return");
          case 1:
            _context8.next = 2;
            return car.dispatch('modifyData', formCarData);
          case 2:
            result = _context8.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context8.next = 3;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context8.abrupt("return");
          case 3:
            $f7.toast.show({
              text: locale.translate('car.edit.updatedCarMessage')
            });
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function saveCarData() {
      return _ref9.apply(this, arguments);
    };
  }();
  var saveCarImage = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var formCarImage, referenceId, fileIds, result;
      return _regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (!(document.getElementById('car-image-file').files[0] == undefined)) {
              _context9.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('car.edit.selectFileToUpload')
            });
            return _context9.abrupt("return");
          case 1:
            formCarImage = new FormData();
            referenceId = $('#car-id').val();
            fileIds = $('#car-file-id').val();
            formCarImage.append('ReferenceId', referenceId);
            formCarImage.append('FileIds', fileIds);
            formCarImage.append('car[]', document.getElementById('car-image-file').files[0]);
            _context9.next = 2;
            return file.dispatch('uploadCarImage', formCarImage);
          case 2:
            result = _context9.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context9.next = 3;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context9.abrupt("return");
          case 3:
            $f7.toast.show({
              text: locale.translate('car.edit.carImageUploadedOkMessage')
            });
          case 4:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function saveCarImage() {
      return _ref0.apply(this, arguments);
    };
  }();
  var saveCarPlate = /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
      var formCarPlateData, referenceId, fileIds, result;
      return _regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            if (!(document.getElementById('car-plate-file').files[0] == undefined)) {
              _context0.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('car.edit.selectFileToUpload')
            });
            return _context0.abrupt("return");
          case 1:
            formCarPlateData = new FormData();
            referenceId = $('#car-id').val();
            fileIds = $('#car-plate-file-id').val();
            formCarPlateData.append('ReferenceId', referenceId);
            formCarPlateData.append('FileIds', fileIds);
            formCarPlateData.append('plate[]', document.getElementById('car-plate-file').files[0]);
            _context0.next = 2;
            return file.dispatch('uploadCarPlate', formCarPlateData);
          case 2:
            result = _context0.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context0.next = 3;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context0.abrupt("return");
          case 3:
            $f7.toast.show({
              text: locale.translate('car.edit.carPlateUploadedOkMessage')
            });
          case 4:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    return function saveCarPlate() {
      return _ref1.apply(this, arguments);
    };
  }();
  var saveCarImageList = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
      var totalSelectedFiles, formCarImageList, referenceId, fileIds, i, result;
      return _regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            totalSelectedFiles = uploadCarFileList.cachedFileArray.length;
            if (!(totalSelectedFiles < 6)) {
              _context1.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('car.edit.uploadCarImagesLimitMessage')
            });
            return _context1.abrupt("return");
          case 1:
            formCarImageList = new FormData();
            referenceId = $('#car-id').val();
            fileIds = $('#car-image-file-list').val();
            formCarImageList.append('ReferenceId', referenceId);
            formCarImageList.append('FileIds', fileIds);
            for (i = 0; i < totalSelectedFiles; i++) {
              formCarImageList.append("car-images[".concat(i, "]"), uploadCarFileList.cachedFileArray[i]);
            }
            _context1.next = 2;
            return file.dispatch('uploadCarImages', formCarImageList);
          case 2:
            result = _context1.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context1.next = 3;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context1.abrupt("return");
          case 3:
            $f7.toast.show({
              text: locale.translate('car.edit.carImageListUploadedOkMessage')
            });
          case 4:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
    return function saveCarImageList() {
      return _ref10.apply(this, arguments);
    };
  }();
  var saveCarRestrictedDates = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var restrictedDateList, i, data, result;
      return _regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (!(restrictorCalendar.value == undefined || restrictorCalendar.value.length == 0)) {
              _context10.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('car.edit.errorRestrictedDate')
            });
            return _context10.abrupt("return");
          case 1:
            restrictedDateList = [];
            for (i = 0; i < restrictorCalendar.value.length; i++) {
              restrictedDateList.push(dayjs(restrictorCalendar.value[i]).format('YYYY-MM-DD'));
            }
            data = {
              carId: props.details.CarMainData.CarId,
              itemsToSave: restrictedDateList
            };
            _context10.next = 2;
            return restrictedDate.dispatch('saveData', data);
          case 2:
            result = _context10.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context10.next = 3;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context10.abrupt("return");
          case 3:
            _context10.next = 4;
            return restrictedDatesLibrary.refreshDisabledDates(carId);
          case 4:
            disabledDates = restrictedDatesLibrary.disabledDates;
            restrictorCalendar.destroy();
            configRestrictorCalendar();
            updateDisabledDates();
            $f7.toast.show({
              text: locale.translate('car.edit.messageRestrictedDate')
            });
          case 5:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function saveCarRestrictedDates() {
      return _ref11.apply(this, arguments);
    };
  }();
  var deleteCarRestrictedDates = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      return _regeneratorRuntime.wrap(function (_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            $f7.dialog.confirm(locale.translate('car.edit.confirmDeleteRestrictedDate'), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
              var result;
              return _regeneratorRuntime.wrap(function (_context11) {
                while (1) switch (_context11.prev = _context11.next) {
                  case 0:
                    _context11.next = 1;
                    return restrictedDate.dispatch('deleteInCar', carId);
                  case 1:
                    result = _context11.sent;
                    if (!(result.status !== undefined && result.status !== 200)) {
                      _context11.next = 2;
                      break;
                    }
                    $f7.toast.show({
                      text: result.data.messages.error
                    });
                    return _context11.abrupt("return");
                  case 2:
                    _context11.next = 3;
                    return restrictedDatesLibrary.refreshDisabledDates(carId);
                  case 3:
                    disabledDates = restrictedDatesLibrary.disabledDates;
                    restrictorCalendar.destroy();
                    configRestrictorCalendar();
                    document.getElementById('restricted-dates').value = "";
                    $update();
                    $f7.toast.show({
                      text: locale.translate('car.edit.messageDeletedRestrictedDate')
                    });
                  case 4:
                  case "end":
                    return _context11.stop();
                }
              }, _callee11);
            })));
          case 1:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function deleteCarRestrictedDates() {
      return _ref12.apply(this, arguments);
    };
  }();
  var updateDisabledDates = function updateDisabledDates() {
    listRestricted = restrictedDatesLibrary.listRestricted;
    if (listRestricted.length > 0) {
      dateValue = "";
      for (var i = 0; i < listRestricted.length; i++) {
        dateValue += dayjs(listRestricted[i]).format('YYYY-MM-DD') + " - ";
      }
      dateValue = dateValue.substring(0, dateValue.length - 3);
    }
    $update();
  };
  var configRestrictorCalendar = function configRestrictorCalendar() {
    restrictorCalendar = $f7.calendar.create({
      inputEl: '#restricted-dates',
      dateFormat: 'yyyy-mm-dd',
      openIn: 'customModal',
      footer: true,
      toolbarCloseText: locale.translate('general.done'),
      rangePicker: true,
      multiple: true,
      disabled: disabledDates,
      on: {
        change: function change(c) {
          var sortedValues = c.value.sort(function (a, b) {
            return a.getTime() - b.getTime();
          });
          c.value = sortedValues;
        }
      }
    });
    $update();
  };
  var goFeatureEdit = function goFeatureEdit(e) {
    e.preventDefault();
    var anchor = e.target.closest("a");
    var subFeatureId = anchor.dataset.subFeatureId;
    if (!(Number(subFeatureId) == 1 || Number(subFeatureId) == 2 || Number(subFeatureId) == 3)) {
      console.log("Invalid subfeature");
      return;
    }
    var list = {};
    var title = '';
    switch (Number(subFeatureId)) {
      case 1:
        list = props.details.CarFeatureList;
        title = 'features';
        break;
      case 2:
        list = props.details.CarUseRestrictionList;
        title = 'restrictions';
        break;
      case 3:
        list = props.details.CarPenaltyUseList;
        title = 'penalties';
        break;
      default:
      // code block
    }
    if (Object.keys(list).length === 0) {
      console.log("List of subfeatures not defined");
      return;
    }
    var obj = {
      props: {
        'list': list
      }
    };
    obj.props.titleDialog = locale.translate("car.".concat(title, ".titleDialog"));
    obj.props.titleShort = locale.translate("car.".concat(title, ".titleShort"));
    $f7.views.main.router.navigate('/car-features-edit/', obj);
    $update();
  };
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div id="${props.details.tabId}" class="page-content ${props.details.isTab && $h`tab`}">
  <div class="">
    <div class="block-title">${locale.translate('car.edit.title')}</div>
    <form id="car-form-edition" class="list no-hairlines-md block block-strong inset">
      <input id="car-id" name="CarId" type="hidden" value="${props.details.CarMainData.CarId}" />
      <div class="list">
        <ul>
          <li>
            <span class="block">${locale.translate('car.edit.useMyCarLabel')}: </span>
            <label class="toggle toggle-init">
              <input id="car-is-used" name="CarIsUsed" type="checkbox" @click="${checkUseCar}" checked="${props.details.CarMainData.CarStatusId == 1 && $h`checked`}" class="${props.details.CarMainData.CarStatusId > 1 && $h`disabled`}" />
              <span class="toggle-icon"></span>
            </label>
          </li>
        </ul>
      </div>
      <ul id="use-car-section" class="${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}">
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.manufacturerLabel')}</div>
              <div class="item-input-wrap">
                <input id="car-manufacturer-name" name="CarManufacturerName" type="text" placeholder="${locale.translate('car.edit.manufacturerLabel')}" autocomplete="off" value="${details.CarMainData.CarManufacturerName}"/>
                <input id="car-manufacturer-id" name="CarManufacturerId" type="hidden" value="${details.CarMainData.CarManufacturerId}"/>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.modelLabel')}</div>
              <div class="item-input-wrap">
                <input id="car-model" name="CarModel" type="text" placeholder="${locale.translate('car.edit.modelLabel')}" autocomplete="off" value="${details.CarMainData.CarModel}"/>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.yearLabel')}</div>
              <div class="item-input-wrap">
                <input id="car-year" name="CarYear" type="number" placeholder="${locale.translate('car.edit.yearLabel')}" autocomplete="off" value="${details.CarMainData.CarYear}"/>
              </div>
            </div>
          </div>
        </li>
        <li>
          <a id="smart-select-car-size" href="#" class="item-link smart-select" data-searchbar="false" data-close-on-select="true">
            <select id="car-size" name="CarSize" @change="${checkPrice}">
            ${carPricings.map((list) => $h`
              <option value="${list.CarSizeIndex}" selected="${parseInt(details.CarMainData.CarSize, 10) === parseInt(list.CarSizeIndex, 0) && $h`selected`}">
                ${locale.translate(`general.sizeList[${list.CarSizeIndex}]`)}
              </option>
            `)}  
            </select>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title">${locale.translate('car.edit.carSize')}</div>
                <div class="item-after">${locale.translate(`general.sizeList[${details.CarMainData.CarSize}]`)}</div>
              </div>
            </div>
          </a>
        </li>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.priceLabel')}</div>
              <div class="item-input-wrap">
                <input id="car-price-rent" name="CarPriceRent" type="number" placeholder="${locale.translate('car.edit.priceLabel')}" autocomplete="off" 
                value="${details.CarMainData.CarPriceRent}" @blur="${checkPrice}"/>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.licensePlate')}</div>
              <div class="item-input-wrap">
                <input id="car-license-plate" name="CarLicensePlate" type="text" placeholder="${locale.translate('car.edit.licensePlate')}" autocomplete="off" value="${details.CarMainData.CarLicensePlate}"/>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.descriptionLabel')}</div>
              <div class="item-input-wrap">
                <textarea id="car-owner-description" name="CarOwnerDescription" rows="10" cols="50">${details.CarMainData.CarOwnerDescription}</textarea>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.carPreferredDeliveryTime')}</div>
              <div class="item-input-wrap">
                <input id="car-preferred-delivery-time" name="CarPreferredDeliveryTime" type="text" readonly="readonly" value="${props.details.CarMainData.CarPreferredDeliveryTime}"/>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.carPreferredReturnTime')}</div>
              <div class="item-input-wrap">
                <input id="car-preferred-return-time" name="CarPreferredReturnTime" type="text" readonly="readonly" value="${props.details.CarMainData.CarPreferredReturnTime}"/>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div id="save-car-data-section" class="${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}">
            <div class="grid grid-cols-3 xlarge-grid-cols-3">
              <div></div>
              <div>
                <a href="#" class="button button-small button-fill color-green" @click="${saveCarData}">
                  <span class="material-symbols-outlined">directions_car</span><span class="hidden-xs-down">${locale.translate('car.edit.carSave')}</span>
                </a>
              </div>
              <div></div>
            </div>
          </div>
        </li>
      </ul>
    </form>
    <div id="car-restricted-dates-section" class="list no-hairlines-md block block-strong inset">
      <ul>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.selectRestrictedDateLabel')}</div>
              <div class="item-input-wrap">
                <textarea id="restricted-dates" name="RestrictedDates" readonly="readonly" @click="${showRestrictingCalendar}"
                placeholder="${locale.translate('car.edit.selectRestrictedDatePlaceholder')}" rows="10" cols="50">${dateValue}</textarea>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="">
            <p class="grid grid-cols-3 xlarge-grid-cols-3 grid-gap">
              <div>
                <a id="car-restricted-dates-save" href="#" class="button button-small button-fill button-raised ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}" @click="${saveCarRestrictedDates}">
                  <span class="material-symbols-outlined">event_busy</span><span class="hidden-xs-down">${locale.translate('car.edit.saveRestrictedDates')}</span>
                </a>
              </div>
              <div>
                <a id="car-restricted-dates-select" href="#" class="button button-small button-fill color-blue button-raised ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}" @click="${showRestrictingCalendar}">
                  <span class="material-symbols-outlined">free_cancellation</span><span class="hidden-xs-down">${locale.translate('car.edit.selectRestrictedDates')}</span>
                </a>
              </div>
              <div>
                <a id="car-restricted-dates-delete-all" href="#" class="button button-small color-teal button-fill button-raised ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}" @click="${deleteCarRestrictedDates}">
                  <span class="material-symbols-outlined">delete</span><span class="hidden-xs-down">${locale.translate('car.edit.deleteAllRestrictedDates')}</span>
                </a>
              </div>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div id="car-image-upload-section" class="list no-hairlines-md block block-strong inset">
      <ul>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.carImageUploadLabel')}</div>
              <div class="item-input-wrap">
                <input id="car-file-id" name="CarFileId" type="hidden" value="${carFile.fileId}" />
                <input id="car-image-file" name="CarImageFile" type="file" class="js-fileinput-car" accept="image/jpeg,image/jpg" />
                <img id="car-img" width="284" height="160"class="${isCarImageEmpty && $h`hideable`}" src="${url}/${details.CarMainData.FilePath}/${details.CarMainData.FileName}" alt="Waiting image..." />
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="">
        <p class="grid grid-cols-3 xlarge-grid-cols-3">
          <div></div>
          <div>
            <a id="car-image-save" href="#" class="button button-small button-fill button-raised color-lightblue ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}" @click="${saveCarImage}">
              <span class="material-symbols-outlined">photo_camera</span><span class="hidden-xs-down">${locale.translate('car.edit.carImageUploadSave')}</span>
            </a>
          </div>
          <div></div>
        </p>
      </div>
    </div>
    <div id="car-image-plate-upload-section" class="list no-hairlines-md block block-strong inset">
      <ul>
        <li>
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('car.edit.carPlateUploadLabel')}</div>
              <div class="item-input-wrap">
                <input id="car-plate-file-id" name="CarPlateFileId" type="hidden" value="${plateFile.fileId}" />
                <input id="car-plate-file" name="CarPlateFile" type="file" class="js-fileinput-car-plate" accept="image/jpeg,image/jpg" />
                <img id="car-plate-img" width="284" height="160" class="${isCarPlateEmpty && $h`hideable`}" src="${plateFile.url}" alt="Waiting image..." />
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="">
        <p class="grid grid-cols-3 xlarge-grid-cols-3">
          <div></div>
          <div>
            <a id="car-plate-save" href="#" class="button button-small button-fill button-raised color-orange ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}" @click="${saveCarPlate}">
              <span class="material-symbols-outlined">photo_camera</span><span class="hidden-xs-down">${locale.translate('car.edit.carPlateUploadSave')}</span>
            </a>
          </div>
          <div></div>
        </p>
      </div>
    </div>
    <div class="no-hairlines-md block block-strong inset">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a id="car-features-button" href="#" data-sub-feature-id="1" @click="${goFeatureEdit}"
          class="button button-small button-fill popup-open ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}">
            <span class="material-symbols-outlined">list</span><span class="hidden-xs-down">${locale.translate('car.edit.carFeatureLabel')}</span>
          </a>
        </div>
        <div></div>
      </p>
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a id="car-features-button" href="#" data-sub-feature-id="2" @click="${goFeatureEdit}"
          class="button button-small button-fill popup-open color-green ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}">
            <span class="material-symbols-outlined">lock_open</span><span class="hidden-xs-down">${locale.translate('car.edit.carUseRestrictionLabel')}</span>
          </a>
        </div>
        <div></div>
      </p>
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a id="car-features-button" href="#" data-sub-feature-id="3" @click="${goFeatureEdit}"
          class="button button-small button-fill popup-open color-teal ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}">
            <span class="material-symbols-outlined">receipt_long_off</span><span class="hidden-xs-down">${locale.translate('car.edit.penaltiesForMisusing')}</span>
          </a>
        </div>
        <div></div>
      </p>
    </div>
    <div class="no-hairlines-md block block-strong inset">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill color-lime ${carImageListPhotos.length < 1  && $h`disabled`}" @click=${openCarImageListBrowser}>
            <span class="material-symbols-outlined">image</span><span class="hidden-xs-down">${locale.translate('car.edit.carImagesPhotoBrowserLabel')}</span>
          </a>
        </div>
        <div></div>
      </p>
      <input id="car-image-file-list" name="CarImageFileList" type="hidden" value="${carImageFileList}" />
      <div id="file-car-images" class="custom-file-container list block text-align-center ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}" 
        data-upload-id="car-data-images">
      </div>
      <div class="block block-strong inset">
        <p class="grid grid-cols-3 xlarge-grid-cols-3">
          <div></div>
          <div>
            <a id="car-image-list-save" href="#" class="button button-small button-fill button-raised color-blue ${props.details.CarMainData.CarStatusId != 1 && $h`disabled`}" @click="${saveCarImageList}">
              <span class="material-symbols-outlined">photo_camera</span><span class="hidden-xs-down">${locale.translate('car.edit.carImageFileListLabel')}</span>
            </a>
          </div>
          <div></div>
        </p>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
};
//Export component name
export default CarDataTab;

//On template use:
//<${CarDataTab} details="pend..." />